import { render, staticRenderFns } from "./CrashLogList.vue?vue&type=template&id=2af7c94b&scoped=true"
import script from "./CrashLogList.vue?vue&type=script&lang=js"
export * from "./CrashLogList.vue?vue&type=script&lang=js"
import style0 from "./CrashLogList.vue?vue&type=style&index=0&id=2af7c94b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2af7c94b",
  null
  
)

export default component.exports